import { DateRange } from '@app/shared/models/date-range';
import {
  currentMonth,
  currentQuarter,
  currentWeek,
  lastMonth,
  lastQuarter,
  lastWeek,
  todayAsRange,
  yesterdayAsRange,
} from '@app/utils/date-range';

interface QuickRangeMappingFunction {
  (today: Date): DateRange;
}

export enum QuickRange {
  CurrentMonth = 'CurrentMonth',
  CurrentQuarter = 'CurrentQuarter',
  CurrentWeek = 'CurrentWeek',
  PreviousMonth = 'PreviousMonth',
  PreviousQuarter = 'PreviousQuarter',
  PreviousWeek = 'PreviousWeek',
  Today = 'Today',
  Yesterday = 'Yesterday',
}

export const QuickRangeMapping: Record<QuickRange, QuickRangeMappingFunction> = {
  [QuickRange.CurrentMonth]: currentMonth,
  [QuickRange.CurrentQuarter]: currentQuarter,
  [QuickRange.CurrentWeek]: currentWeek,
  [QuickRange.PreviousMonth]: lastMonth,
  [QuickRange.PreviousQuarter]: lastQuarter,
  [QuickRange.PreviousWeek]: lastWeek,
  [QuickRange.Today]: todayAsRange,
  [QuickRange.Yesterday]: yesterdayAsRange,
};

export function quickRangeToDate(quickRange: QuickRange, today: Date = new Date()): DateRange | null {
  return QuickRangeMapping[quickRange]?.(today) ?? null;
}
